import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { createHistoryStorage } from '@snapask/common-components/dist/utils/history';

import configureStore from './store/configureStore';
import { readCookie } from './services/cookies';

import { INIT_STATE as activeQuestionsInitialState } from '@coconut/scenes/Home/services/redux/activeQuestions';
import { save, load } from '@coconut/utils/localQuestionListTutorial';
import { initialState as QUESTIONLIST_TUTORIAL_EMPTY_STATES } from '@coconut/services/redux/questionListTutorial';

import {
  QUESTION_LIST_TUTORIAL_STAGE,
  CHAT_TUTORIAL_STAGE,
  TOKEN,
  USER_DATA,
  QUESTION_ID,
  USER_LANG,
  UN_SENT_MESSAGE,
} from '@coconut/constants/cookieName';

class ProviderWithRouter extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    initialState: PropTypes.object,
    rootReducer: PropTypes.func, // eslint-disable-line react/require-default-props
    history: PropTypes.object.isRequired, // eslint-disable-line
  };

  static defaultProps = {
    initialState: {},
  };

  constructor(props) {
    super(props);

    const { initialState, rootReducer, history } = props;

    const token = readCookie(TOKEN);
    const userData = readCookie(USER_DATA);
    const lang = readCookie(USER_LANG);
    const chatCurrentStage = this.parseCookieToInt(CHAT_TUTORIAL_STAGE, 0);
    const nonLoginQuestionId = this.parseCookieToInt(QUESTION_ID, 0);
    const questionListCurrentStage = this.parseCookieToInt(
      QUESTION_LIST_TUTORIAL_STAGE,
      0
    );
    const unSentMessage = readCookie(UN_SENT_MESSAGE);
    const unSentMessageData = unSentMessage ? JSON.parse(unSentMessage) : {};

    const {
      userId,
      username,
      firstName,
      lastName,
      role,
      email,
      avatar,
      countryCode,
    } = userData ? JSON.parse(userData) : {};
    // get tutorialSteps from localStorage
    let questionListTutorialSteps = load();

    if (!questionListTutorialSteps) {
      save(QUESTIONLIST_TUTORIAL_EMPTY_STATES);
      questionListTutorialSteps = QUESTIONLIST_TUTORIAL_EMPTY_STATES;
    }

    this.store = configureStore(
      rootReducer,
      {
        ...initialState,
        app: {
          locale: lang,
          subjects: [],
        },
        auth: {
          token,
        },
        profile: {
          data: {
            userId,
            username,
            firstName,
            lastName,
            role,
            email,
            avatar,
            countryCode,
          },
        },
        questions: {
          activeQuestions: {
            ...activeQuestionsInitialState,
            nonLoginQuestionId,
          },
        },
        questionListTutorial: {
          ...questionListTutorialSteps,
        },
        tutorial: {
          questionListCurrentStage,
          chatCurrentStage,
        },
        chat: {
          chatsMessage: {
            unSentMessage: unSentMessageData,
            currentMessages: [],
          },
        },
      },
      { history }
    );

    this.state = { lang };
  }

  getChildContext() {
    const { lang } = this.state;

    return {
      lang,
    };
  }

  componentDidMount() {
    createHistoryStorage(location.pathname);
    this.props.history.listen((location) => {
      createHistoryStorage(location.pathname);
    });
  }

  parseCookieToInt = (name, defaultValue) =>
    parseInt(readCookie(name), 10) || defaultValue;

  render() {
    return <Provider store={this.store}>{this.props.children}</Provider>;
  }
}

ProviderWithRouter.childContextTypes = {
  lang: PropTypes.string,
};

export default withRouter(ProviderWithRouter);



// WEBPACK FOOTER //
// ./src/ProviderWithRouter.jsx